module.exports = __webpack_public_path__ + "media/images/front/popular_contents_01-94d8d46aa66c341f22e97d3cbbb95fb9.jpg";